import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { alpha } from '@mui/material';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Container from '@mui/material/Container';
import MuiLink from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import React from 'react';

const Header: React.FC<IProps<IHeader>> = ({ data }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        py: 8,
        bgcolor: (theme) =>
          theme.palette.mode === 'dark'
            ? `${alpha(theme.palette.action.active, 0.02)}`
            : theme.palette.grey.A200,
      }}
    >
      <Container>
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ mt: 6 }}
        >
          <Typography
            component="h1"
            variant="h1"
            color="text.primary"
            textAlign="center"
          >
            {data.title}
          </Typography>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {data.links.map((el, i) => (
              <Link href={el.path} passHref key={el._id}>
                <MuiLink underline="hover" key="2" color="text.secondary">
                  {el.label}
                </MuiLink>
              </Link>
            ))}
            <Typography color="text.primary">{data.current}</Typography>
          </Breadcrumbs>
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
